import { cn } from '@/lib/utils'

interface IProps {
    className?: string
    colorBgClass?: string
}

export default function LoadingBar({
    className,
    colorBgClass = 'bg-foreground/20',
}: IProps) {
    return (
        <div
            className={cn(
                'relative w-full h-1 bg-muted/50 overflow-hidden',
                className,
            )}
        >
            <div
                className={cn(
                    'absolute inset-0 size-full animate-wave',
                    colorBgClass,
                )}
            ></div>
        </div>
    )
}
